var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7493 8.00033C15.7752 8.00033 17.416 6.35949 17.416 4.33366C17.416 2.30783 15.7752 0.666992 13.7493 0.666992C11.7235 0.666992 10.0827 2.30783 10.0827 4.33366C10.0827 6.35949 11.7235 8.00033 13.7493 8.00033ZM5.49935 6.16699V3.41699H3.66602V6.16699H0.916016V8.00033H3.66602V10.7503H5.49935V8.00033H8.24935V6.16699H5.49935ZM13.7493 9.83366C11.3018 9.83366 6.41602 11.062 6.41602 13.5003V15.3337H21.0827V13.5003C21.0827 11.062 16.1968 9.83366 13.7493 9.83366Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.d235da5b6edc7aaec70c600959e8b9cb.svg";
export { ForwardRef as ReactComponent };